import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { calculateAmount, looseDiamondId, looseStoneId } from "utils/helpers";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import GetApiService from "Components/Api/getapiService";
import { useSelector } from "react-redux";
import zIndex from "@mui/material/styles/zIndex";
import toast from "react-hot-toast";
import useDebounce from "hooks/useDebounce";
import { fetchAllLabelledStock } from "services/generalService";
import styles from "../Pages/PagesStyles/InvoiceEntryNew.module.css";
import useScreenSize from "hooks/useScreenSize";
import "./smallTable.css";

const selectStyle = {
  control: (base) => ({
    ...base,
    minHeight: "20px",
    height: "25px",
    width: "150px",
    zIndex: '10'
  }),
  placeholder: (base) => ({
    ...base,
    color: "#aaa",
    fontStyle: "italic",
    display: "none",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "blue"
      : state.isFocused
      ? "lightblue"
      : "white",
    color: state.isSelected ? "white" : "black",
    padding: "6px",
    fontSize: "12px",
    whiteSpace: "normal", // Allows text to wrap instead of truncating
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    padding: "2px 2px 2px 0px", // Decreases padding inside the input box
    whiteSpace: "normal", // Allows full text to display
    textOverflow: "unset", // Removes ellipsis
    overflow: "visible", // Ensures full visibility of text
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    marginTop: "5px",
    zIndex: 999,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "100px", // Ensures the dropdown has a scrollable height
    overflowY: "auto", // Enables scrolling for overflow
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    svg: {
      width: "12px",
      height: "12px",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0px",
  }),
};

const QuotationWholeSaleSummary = ({
  skus,
  setIsSummaryOpen,
  setValue,
  setEditValues,
  setEdit,
  addSku,
}) => {
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);

  const [rateForAll, setRateForAll] = useState(0);
  const [itemCode, setItemCode] = useState();
  const debouncedItemCode = useDebounce(itemCode, 1500);
  const [hallmarkForAll, setHallmarkForAll] = useState(0);
  const [labeledStockList, setLabeledStockList] = useState([]);
  const [loading, setLoading] = useState(false);
  const debouncedRateForAll = useDebounce(rateForAll, 1500);
  const debouncedHallmarkForAll = useDebounce(hallmarkForAll, 1500);
  const [selectedOption, setSelectedOption] = useState(null);

  // const {
  //   data: labeledStockList,
  //   isLoading,
  //   isError,
  //   refetch,
  // } = useQuery({
  //   queryKey: ["getLabeledStock",clientCode],
  //   queryFn: fetchAllLabelledStock,
  //   refetchOnWindowFocus: false,

  // });
  const [total, setTotal] = useState({
    TotalFineMetal: 0,
    TotalStoneWt: 0,
    TotalGrossWt: 0,
    TotalStoneWeight: 0,
    TotalStonePieces: 0,
    NetWt: 0,
    FinePercent: 0,
    WastagePercent: 0,
    TotalFineWastageWt: 0,
    TotalStoneAmount: 0,
    TotalQty: 0,
    TotalPieces: 0,
    TotalHallmarkAmount: 0,
    TotalPackingWt: 0,
    TotalDiamondwt: 0,
    TotalMRP: 0,
    TotalItemAmount: 0,
    TotalURDAmount: 0,
  });
  const [invoiceItem, setInvoiceItem] = useState();

  const isSmallScreen = useScreenSize(); // Get screen size

  useEffect(() => {
    // .filter((item)=>item?.Status == "Active")
    // setLabeledStockList
    if (debouncedItemCode?.trim()) {
      handleInputChange(debouncedItemCode);
    }
  }, [debouncedItemCode]);

  useEffect(() => {
    if (
      labeledStockList?.length &&
      itemCode &&
      (labeledStockList[0]?.ItemCode == itemCode ||
        labeledStockList[0]?.RFIDCode == itemCode)
    ) {
      const isAvailable = skus?.length
        ? skus?.filter(
            (item) => item?.ItemCode == itemCode || item?.RFIDCode == itemCode
          )
        : [];
        setItemCode("");
        setSelectedOption({ label: "", value: 0 });
      if (isAvailable?.length) {
        toast.error("Item already added", {
          position: "top-center",
          duration: 3000,
        });
    
      } else {
        addSku(labeledStockList[0], true);
        
      }
    }
  }, [labeledStockList, itemCode]);

  const handleInputChange = async (ItemCode) => {
    setLoading(true);
    try {
      const response = await fetchAllLabelledStock({
        queryKey: [, clientCode, ItemCode],
      }); // Call the API with the input value
      const result = response?.filter((item) => item?.Status == "Active");
      setLabeledStockList(result); // Update the options based on the API response
    } catch (error) {
      console.error("Error fetching options:", error);
      toast.error("Failed to load options. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    setValue(
      "skus",
      skus.filter((sku) => sku.id !== id)
    );
  };
  const handleEdit = (item, index) => {
    // const data = skus.find((_,i) => i != index);
    // console.log(data)
    const data = {
      ...item,

      StockKeepingUnit: { value: item?.SKUId, label: item?.SKU },
      CategoryId: { value: item?.CategoryId, label: item?.CategoryName },
      ProductId: { value: item?.ProductId, label: item?.ProductName },
      DesignId: { value: item?.DesignId, label: item?.DesignName },
      PurityId: { value: item?.PurityId, label: item?.PurityName },
      TotalWt: (+(item?.TotalWeight || 0))?.toFixed(3),
      PackingWt: (+(item?.PackingWeight || 0))?.toFixed(3),
      GrossWt:(+(item?.GrossWt || 0))?.toFixed(3),
      StoneWt: (+(item?.TotalStoneWeight || 0))?.toFixed(3),
      DiamondWeight: item?.TotalDiamondWeight || item?.DiamondWeight || "",
      NetWt: (+(item?.NetWt || 0))?.toFixed(3),
      GoldRate: (+(item?.MetalRate))?.toFixed(2),
      Qty: item?.Qty || item?.Pieces,
      FinePercent: item?.FinePercent,
      MakingPercent: item?.MakingPercentage,
      MakingPerGram: (+(item?.MakingPerGram || 0))?.toFixed(2),
      MakingFixedAmt: (+(item?.MakingFixedAmt || 0))?.toFixed(2),
      MakingFixedWastage: (+(item?.MakingFixedWastage  || 0))?.toFixed(2),
      StonePieces: item?.TotalStonePieces,
      StoneAmount: (+(item?.TotalStoneAmount || 0))?.toFixed(2),
      Hallmark: (+(item?.HallmarkAmount || 0))?.toFixed(2),
      MetalAmount: (+(item?.MetalAmount || 0))?.toFixed(2),
      CuttingGrossWt: (+(item?.CuttingGrossWt || 0))?.toFixed(3),
      CuttingNetWt: (+(item?.CuttingNetWt || 0))?.toFixed(3),
      MRP: (+(item?.MRP || 0))?.toFixed(2),
      index,
    };
    console.log(data);
    setEditValues(data);
    setEdit(true);
    setIsSummaryOpen(false);
  };

  useEffect(() => {
    if (skus?.length) {
      let totalFineMetal = 0;
      let totalWt = 0;
      let GrossWt = 0;
      let TotalStoneWeight = 0;
      let NetWt = 0;
      let FinePercent = 0;
      let WastagePercent = 0;
      let FineWastageWt = 0;
      let stonePieces = 0;
      let TotalStoneAmount = 0;
      let TotalQty = 0;
      let TotalPieces = 0;
      let TotalHallmarkAmount = 0;
      let TotalPackingWt = 0;
      let TotalDiamondwt = 0;
      let TotalMRP = 0;
      let TotalItemAmount = 0;
      let FinalAmount = 0;
      let URDAmount = 0;

      skus?.forEach((item) => {
        totalFineMetal += +item?.FineWastageWt;
        totalWt += +item?.TotalWeight;
        GrossWt += +item?.GrossWt;
        TotalStoneWeight += +item?.TotalStoneWeight;
        NetWt += +item?.NetWt;
        FinePercent += +item?.FinePercent;
        WastagePercent += +item?.WastagePercent;
        FineWastageWt += +(item?.FineWastageWt || 0);
        TotalStoneAmount += +item?.TotalStoneAmount;
        TotalQty += +item?.Qty;
        TotalPieces += +(item?.Pieces || 0);
        TotalHallmarkAmount += +item?.HallmarkAmount;
        TotalPackingWt += +item?.PackingWeight;
        TotalDiamondwt += +item?.TotalDiamondWeight;
        FinalAmount += +(item?.MRP || 0)
          ? +(item?.MRP || 0)
          : +(item?.TotalItemAmount || 0);
        TotalMRP += +item?.MRP;
        TotalItemAmount += item?.TotalItemAmount ? +item?.TotalItemAmount : 0;
        URDAmount += +(item?.Amount || 0);
      });
      setValue("TotalFineMetal", (totalFineMetal || 0)?.toFixed(3));
      setValue("TotalTaxableAmount", (FinalAmount || 0)?.toFixed(2));
      setValue("TotalURDAmount", (URDAmount || 0)?.toFixed(2));
      setTotal({
        TotalFineMetal: totalFineMetal ? totalFineMetal : 0,
        TotalStoneWt: totalWt ? totalWt : 0,
        TotalGrossWt: GrossWt ? GrossWt : 0,
        TotalStoneWeight: TotalStoneWeight ? TotalStoneWeight : 0,
        TotalStonePieces: stonePieces ? stonePieces : 0,
        NetWt: NetWt ? NetWt : 0,
        FinePercent: FinePercent ? FinePercent : 0,
        WastagePercent: WastagePercent ? WastagePercent : 0,
        TotalFineWastageWt: FineWastageWt ? FineWastageWt : 0,
        TotalStoneAmount: TotalStoneAmount ? TotalStoneAmount : 0,
        TotalQty: TotalQty ? TotalQty : 0,
        TotalPieces: TotalPieces ? TotalPieces : 0,
        TotalHallmarkAmount: TotalHallmarkAmount ? TotalHallmarkAmount : 0,
        TotalPackingWt: TotalPackingWt ? TotalPackingWt : 0,
        TotalDiamondwt: TotalDiamondwt ? TotalDiamondwt : 0,
        TotalMRP: TotalMRP ? TotalMRP : 0,
        TotalItemAmount: TotalItemAmount ? TotalItemAmount : 0,
        TotalURDAmount: URDAmount || 0
      });
    }
    if (!skus?.length) {
      setValue("TotalFineMetal", "");
      setValue("TotalTaxableAmount", "");
      setValue("TotalURDAmount", "");
      setTotal({
        TotalFineMetal: "",
        TotalStoneWt: "",
        TotalGrossWt: "",
        TotalStoneWeight: "",
        TotalStonePieces: "",
        NetWt: "",
        FinePercent: "",
        WastagePercent: "",
        TotalFineWastageWt: "",
        TotalStoneAmount: "",
        TotalQty: "",
        TotalPieces: "",
        TotalHallmarkAmount: "",
        TotalPackingWt: "",
        TotalDiamondwt: "",
        TotalMRP: "",
        TotalItemAmount: "",
        TotalURDAmount:""
      });
    }
  }, [skus]);

  useEffect(() => {
    if (debouncedRateForAll) {
      const updatedSkusWithRate = skus?.map((item) => {
        return calculateAmount({ ...item, MetalRate: debouncedRateForAll });
      });
      setValue("skus", updatedSkusWithRate);
    }
    if (debouncedHallmarkForAll) {
      const updatedSkusWithHallmark = skus?.map((item) => {
        return calculateAmount({
          ...item,
          HallmarkAmount: debouncedHallmarkForAll,
        });
      });
      setValue("skus", updatedSkusWithHallmark);
    }
  }, [debouncedRateForAll, debouncedHallmarkForAll]);


 
  let totalItemAmount = skus.reduce(
    (acc, row) => acc + +(row?.MRP || row?.TotalItemAmount || 0),
    0
  );

  return (
    <div className="box1-section">
      <div
        className="table-container"
        style={{
          overflowX: "auto",
          margin: "0",
          padding: "0",
          width: "100%",
          minHeight: "fit-content",
        }}
      >
        {isSmallScreen ? (
          <>
            <div className="small-screen-container">
              <div className="dropdown-container-sm">
                <label style={{ padding: "5px" }}>Select Item</label>
                <Select
                
                  options={
                    labeledStockList?.length
                      ? labeledStockList?.map((item) => {
                          return {
                            value: item?.Id,
                            label: item?.ItemCode,
                            item: item,
                          };
                        })
                      : []
                  }
                  value={selectedOption}
                  onInputChange={(value) => {
                    setItemCode(value);
                  }}
                  onChange={(data) => {
                    const isAvailable = skus?.length
                      ? skus?.filter(
                          (item) => item?.ItemCode == data?.item?.ItemCode
                        )
                      : [];
                    if (isAvailable?.length) {
                      toast.error("Item already added", {
                        position: "top-center",
                        duration: 3000,
                      });
                      setItemCode("");
                      setSelectedOption({ label: "", value: "" });
                    } else {
                      addSku(data?.item, true);
                      setItemCode("");
                      setSelectedOption({ label: "", value: "" });
                    }
                  }}
                  isSearchable={true}
                  isLoading={loading}
                  styles={selectStyle}
                  menuPortalTarget={document.body}
                  menuPosition="absolute"
                />
              </div>

              {skus?.length
                ? skus?.map((row, index) => (
                    <>
                      <div className="item-container-sm">
                        <div key={index} className="item-box">
                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              Item{" "}
                            </p>
                            <p className="small-colName">
                              {row.ItemCode} - {row.ProductName}
                            </p>
                          </div>
                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              HSN
                            </p>
                            <p className="small-colName">
                              {(+(row?.HSNCode || 0))?.toFixed(3)}
                            </p>
                          </div>

                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              Pieces
                            </p>
                            <p className="small-colName">
                              {+(row?.Quantity || 0)}
                            </p>
                          </div>
                        </div>
                        <div key={index} className="item-box">
                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              Gr Wt
                            </p>
                            <p className="small-colName">
                              {(+(row?.GrossWt || 0))?.toFixed(3)}
                            </p>
                          </div>

                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              St Wt
                            </p>
                            <p className="small-colName">
                              {(+(row?.TotalStoneWeight || 0))?.toFixed(3)}
                            </p>
                          </div>
                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              Nt Wt
                            </p>
                            <p className="small-colName">
                              {(+(row?.NetWt || 0))?.toFixed(3)}
                            </p>
                          </div>
                        </div>

                        <div key={index} className="item-box">
                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              Rate/Gm
                            </p>
                            <p className="small-colName">
                              {(+(row?.MetalRate || 0))?.toFixed(2)}
                            </p>
                          </div>

                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              Wastage
                            </p>
                            <p className="small-colName">
                              {(+(row?.MakingPercentage || 0))?.toFixed(2)}
                            </p>
                          </div>

                          <div className="field-box-sm">
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              Stone Amt
                            </p>
                            <p className="small-colName">
                              {(+(row?.StoneAmount || 0))?.toFixed(2)}
                            </p>
                          </div>
                        </div>

                        <div
                          style={{ justifyContent: "end" }}
                          key={index}
                          className="item-box"
                        >
                          <div className="icons-box-sm">
                            <Icon
                              title="edit"
                              icon="material-symbols-light:edit-outline"
                              width="20"
                              height="20"
                              style={{ color: "#0077d4", cursor: "pointer" }}
                              onClick={() => handleEdit(row, index)}
                            />

                            <Icon
                              icon="weui:delete-outlined"
                              width="20"
                              height="20"
                              style={{ color: "#0077d4", cursor: "pointer" }}
                              onClick={() => {
                                handleDelete(row?.id);
                                setValue(
                                  "skus",
                                  skus.filter((_, i) => i !== index)
                                );
                              }}
                            />
                          </div>
                          <div
                            style={{ width: "40%" }}
                            className="field-box-sm"
                          >
                            <p
                              style={{ fontWeight: "bold" }}
                              className="small-colName"
                            >
                              Item Amt
                            </p>
                            <p className="small-colName">
                              {(+( +(row?.TotalItemAmount || 0)
                                ? row?.TotalItemAmount
                                : 0))?.toFixed(2)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ))
                : // <div className="placeholder-box">
                  //   <p style={{fontWeight: 'bold'}} className="small-colName">Item</p>
                  //   <p style={{fontWeight: 'bold'}} className="small-colName">HSN</p>
                  //   <p style={{fontWeight: 'bold'}} className="small-colName">Pieces</p>
                  //   <p style={{fontWeight: 'bold'}} className="small-colName">Gr Wt:</p>
                  //   <p style={{fontWeight: 'bold'}} className="small-colName">St Wt:</p>
                  //   <p style={{fontWeight: 'bold'}} className="small-colName">Nt Wt:</p>
                  //   <p style={{fontWeight: 'bold'}} className="small-colName">Rate/gm</p>
                  //   <p style={{fontWeight: 'bold'}} className="small-colName">Wastage</p>

                  //   <p style={{fontWeight: 'bold'}} className="small-colName">St Amt:</p>

                  // </div>
                  ""}
            </div>

            {/* <div className="total-amount-container">
                  <p  style={{fontWeight: 'bold'}} className="small-colName">
                    Total Items Amount: {totalItemAmount.toFixed(2)}
                  </p>
                </div> */}
          </>
        ) : (
          <div
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              border: "1px solid #ddd",
            }}
          >
            <table
              className="custom-table"
              style={{ width: "100%", borderCollapse: "collapse" }}
            >
              <thead
                style={{ position: "sticky", top: 0, background: "#627282" }}
              >
                <tr>
                  <th
                    style={{
                      fontSize: "12px",
                      width: "30px",
                      minWidth: "30px",
                      textAlign: "left",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Sr.No.
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      width: "300px",
                      minWidth: "300px",
                      textAlign: "left",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Item Details
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      padding: "12px 15px !importaint",
                      fontWeight: "normal",
                    }}
                  >
                    T Wt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Gr Wt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    St Wt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Nt Wt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Fine %
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Wastage %
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    F+W Wt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Rate/Gm
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    St Amt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Qty
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Pieces
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Hallmark Amt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    T Item Amt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Packing Wt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    Dia Wt
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    MRP
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      background: "#627282",
                      color: "#fff",
                      fontWeight: "normal",
                    }}
                  >
                    URD Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {skus?.length
                  ? skus?.map((row, index) => (
                      <tr key={row?.srNo} style={{background:`${row?.OldGoldPurchase ? "#FFFFAD" : ""}`}}>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {index + 1}
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <div
                            style={{
                              display: "flex",

                              fontSize: "12px",
                              width: "fit-content",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <Icon
                              icon="lets-icons:img-box-fill"
                              width="15"
                              height="15"
                              style={{ color: "#627282", cursor: "pointer" }}
                            />
                            <div
                              style={{ display: "flex", alignItems: "start" }}
                            >
                              {row?.ItemCode || ""} - {row?.SKU || ""} - {row?.CategoryName || ""} - {row?.ProductName || ""} - {row?.PurityName || ""}
                            </div>
                            <div
                              style={{
                                flex: "1",
                                display: "flex",
                                // flexDirection: "column",
                                alignItems: "start",
                                justifyContent: "flex-end",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                                title="edit"
                                onClick={() => handleEdit(row, index)}
                              >
                                <Icon
                                  title="edit"
                                  icon="material-symbols-light:edit-outline"
                                  width="15"
                                  height="15"
                                  style={{
                                    color: "#627282",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                                title="delete"
                              >
                                <Icon
                                  icon="weui:delete-outlined"
                                  width="15"
                                  height="15"
                                  style={{
                                    color: "#627282",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    handleDelete(row?.id);
                                    setValue(
                                      "skus",
                                      skus.filter((_, i) => i !== index)
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.TotalWeight || 0)?.toFixed(3)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.GrossWt || 0)?.toFixed(3)}
                        </td>

                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.TotalStoneWeight || 0)?.toFixed(3)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.NetWt || 0)?.toFixed(3)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.FinePercent || 0)?.toFixed(2)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.MakingPercentage || 0)?.toFixed(2)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+(row?.FineWastageWt || 0))?.toFixed(3)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.MetalRate || 0)?.toFixed(2)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.TotalStoneAmount || 0)?.toFixed(2)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {+row?.Qty || 0}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {+row?.Pieces || 0}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.HallmarkAmount || 0)?.toFixed(2)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.TotalItemAmount || 0)?.toFixed(2)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.PackingWeight || 0)?.toFixed(3)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(
                            +row?.DiamondWeight ||
                            +row?.TotalDiamondWeight ||
                            0
                          ).toFixed(3)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.MRP || 0).toFixed(2)}
                        </td>
                        <td style={{ fontSize: "12px", textAlign: "center" }}>
                          {(+row?.Amount || 0).toFixed(2)}
                        </td>
                      </tr>
                    ))
                  : ""}
              </tbody>
              <tfoot
                style={{ position: "sticky", bottom: "0", background: "white" }}
              >
                <tr>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "12px",
                        gap: "5px",
                      }}
                    >
                      <Select
                        options={
                          labeledStockList?.length
                            ? labeledStockList?.map((item) => {
                                return {
                                  value: item?.Id,
                                  label: item?.ItemCode,
                                  item: item,
                                };
                              })
                            : []
                        }
                        value={selectedOption}
                        inputValue={itemCode}
                        onInputChange={(value) => {
                          console.log(value)
                          setItemCode(value);
                        }}
                        onChange={(data) => {
                          console.log(data)
                          setItemCode("");
                          setSelectedOption({ label: "", value: "",item:"" });
                          const isAvailable = skus?.length
                            ? skus?.filter(
                                (item) => item?.ItemCode == data?.item?.ItemCode
                              )
                            : [];
                          if (isAvailable?.length) {
                            toast.error("Item already added", {
                              position: "top-center",
                              duration: 3000,
                            });
                           
                          } else {
                            addSku(data?.item, true);
                            // setItemCode();
                            // setSelectedOption({ label: "", value: "" });
                          }
                        }}
                        isSearchable={true}
                        isLoading={loading}
                        styles={selectStyle}
                      />
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="Add Unlabeled Item"
                      >
                        <Icon
                          icon="weui:add-outlined"
                          onClick={() => {
                            setEdit(false);
                            setIsSummaryOpen(false);
                          }}
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                        />
                      </div>
                    </div>
                  </td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                  <td style={{ fontSize: "12px", textAlign: "center" }}></td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  ></td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    Total
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalStoneWt || 0)?.toFixed(3)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalGrossWt || 0)?.toFixed(3)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalStoneWeight || 0)?.toFixed(3)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.NetWt || 0)?.toFixed(3)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  ></td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  ></td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalFineWastageWt || 0)?.toFixed(3)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    <input
                      style={{
                        border: "solid 1px gray",
                        padding: "4px 0px",
                        textAlign: "center",
                      }}
                      type="text"
                      placeholder="Total Rate"
                      value={rateForAll}
                      onChange={(e) => {
                        let value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setRateForAll(value);
                        }
                      }}
                    />
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalStoneAmount || 0)?.toFixed(2)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {total?.TotalQty || 0}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {total?.TotalPieces || 0}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    <input
                      style={{
                        border: "solid 1px gray",
                        padding: "4px 0px",
                        textAlign: "center",
                      }}
                      type="text"
                      placeholder="Total Hallmark"
                      value={hallmarkForAll}
                      onChange={(e) => {
                        let value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setHallmarkForAll(value);
                        }
                      }}
                    />
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalItemAmount || 0)?.toFixed(2)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalPackingWt || 0)?.toFixed(2)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalDiamondwt || 0)?.toFixed(3)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalMRP || 0)?.toFixed(2)}
                  </td>
                  <td
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      padding: "8px 0px",
                    }}
                  >
                    {(total?.TotalURDAmount || 0)?.toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuotationWholeSaleSummary;
